const EXISTING_OFFICIAL_WHATSAPP_NUMBER = '971555439094';

const normalizeWhatsAppNumber = value => String(value || '').replace(/\D/g, '');

export const CODEWAVE_WHATSAPP_NUMBER =
  normalizeWhatsAppNumber(process.env.REACT_APP_WHATSAPP_NUMBER) || EXISTING_OFFICIAL_WHATSAPP_NUMBER;

export const WHATSAPP_MESSAGES = Object.freeze({
  enrollment: 'مرحباً CodeWave، أرغب في الاستفسار عن الاشتراك والحصول على حساب على المنصة.',
  generalInquiry: 'مرحبًا، شاهدت الإعلان على الموقع وأرغب في معرفة المزيد من التفاصيل.'
});

export const buildWhatsAppUrl = message =>
  `https://wa.me/${CODEWAVE_WHATSAPP_NUMBER}?text=${encodeURIComponent(String(message || ''))}`;
